import { isPrimaryPointer } from './utils/is-primary-pointer.mjs';
function extractEventInfo(event) {
  var pointType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "page";
  return {
    point: {
      x: event["".concat(pointType, "X")],
      y: event["".concat(pointType, "Y")]
    }
  };
}
var addPointerInfo = function addPointerInfo(handler) {
  return function (event) {
    return isPrimaryPointer(event) && handler(event, extractEventInfo(event));
  };
};
export { addPointerInfo, extractEventInfo };